import React from "react";
import Styles from "./ProjectCard.module.css";

const ProjectCard = (props) => {
  return (
    <div className={Styles.ProjectCard}>
      <div className={Styles.ProjectCardWrapper}>
        <img src={props.img} className={Styles.ProjectImage} alt="sgdfg" />
        <p className={Styles.ProjectName}>{props.name}</p>
        <p className={Styles.ProjectDescription}>{props.description}</p>
      </div>
    </div>
  );
};

export default ProjectCard;
